module.exports = __webpack_public_path__ + "static/media/turbo-games.2084e5aa.webp";